import { type FC } from 'react';
import { styled } from 'styled-components';

import { ConnectPopover } from '@/components/Pretzel/ConnectPopover';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';
import { useUserLocale } from '@/i18n/hooks';

interface Props {
  percentage: number;
}

/**
 * Renders a styled text used for displaying a ESG coverage percentage.
 *
 * @param percentage The coverage percentage.
 */
export const EsgCoverageText: FC<Props> = ({ percentage }) => {
  const locale = useUserLocale();
  const texts = useTexts();
  const coverageText = `${
    texts.pages.esg.coverageText
  } ${percentage.toLocaleString(locale)}%`;

  return (
    <StyledWithGap gap="8" direction="row">
      <div className="font-details">{coverageText}</div>
      <ConnectPopover
        id="esg-coverage"
        description={texts.pages.esg.coverageTextHelper}
      />
    </StyledWithGap>
  );
};

const StyledWithGap = styled(WithGap)`
  align-items: center;
`;
